<template>
  <div>
    <MatrixTextTable
      :title="renderDynamicData('title')"
      :fields="fields"
      :items="items"
    />
  </div>
</template>

<script>
import MatrixTextTable from "@/components/global/MatrixTextTable";
import { pathOr, includes } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: {
    MatrixTextTable,
  },
  props: {
    componentType: {
      type: String,
      default: "default",
    },
    code: {
      type: [String, Number],
    },
    calculateData: {
      type: Boolean,
      default: false,
    },
    callInCreatedHook: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      scoreData: [],
      resourceData: [],
    };
  },
  computed: {
    fields() {
      const fieldsObject = {
        default: [
          {
            key: "caption_level_1",
            label: "محور ارزیابی",
            class: "text-center",
            thClass: "p-1 w-25",
            tdClass: "p-1 text-muted font-weight-bold text-left fs_12",
          },
          {
            key: "score",
            label: "وضعیت",
            class: "text-center",
            thClass: "p-1",
            tdClass: "p-1 text-muted fs_12",
          },
          {
            key: "description",
            label: "توضیحات",
            class: "text-center",
            thClass: "p-1 w-75",
            tdClass: "p-1 text-muted text-left fs_12",
          },
        ],
        reportConclusion: [
          {
            key: "caption_level_1",
            label: "جمع بندی",
            class: "text-center",
            thClass: "p-1",
            tdClass: "p-1 text-muted font-weight-bold text-left fs_12",
          },
          {
            key: "score0",
            label: "مصاحبه",
            class: "text-center",
            thClass: "p-1",
            tdClass: "p-1 text-muted fs_12",
          },
          {
            key: "score1",
            label: "تحقیقات",
            class: "text-center",
            thClass: "p-1",
            tdClass: "p-1 text-muted fs_12",
          },
        ],
        reportResource: [
          {
            key: "row",
            label: "ردیف",
            class: "text-center",
            thClass: "p-1",
            tdClass: "p-1 text-muted font-weight-bold text-center fs_12",
          },
          {
            key: "reference_full_name",
            label: "نام و نام خانوادگی",
            class: "text-center",
            thClass: "p-1",
            tdClass: "p-1 text-muted font-weight-bold text-center fs_12",
          },
          {
            key: "education_field",
            label: "رشته",
            class: "text-center",
            thClass: "p-1",
            tdClass: "p-1 text-muted font-weight-bold text-center fs_12",
          },
          {
            key: "education_grade",
            label: "سطح تحصیلات",
            class: "text-center",
            thClass: "p-1",
            tdClass: "p-1 text-muted font-weight-bold text-center fs_12",
          },
          {
            key: "work_location",
            label: "محل کار",
            class: "text-center",
            thClass: "p-1",
            tdClass: "p-1 text-muted font-weight-bold text-center fs_12",
          },
          {
            key: "know_level",
            label: "سطح شناخت از داوطلب",
            class: "text-center",
            thClass: "p-1",
            tdClass: "p-1 text-muted font-weight-bold text-center fs_12",
          },
          {
            key: "final_assessment",
            label: "ارزیابی محقق از صداقت منبع",
            class: "text-center",
            thClass: "p-1",
            tdClass: "p-1 text-muted font-weight-bold text-center fs_12",
          },
        ],
      };
      return includes(this.componentType, ["reportSearch", "reportInterview"])
        ? fieldsObject.default
        : fieldsObject[this.componentType];
    },
    items() {
      const refactorScoreData = this.scoreData.map((item) => {
        const itemScore0 = this.scoreData.find(
          (i) =>
            i.caption_level_1 === item.caption_level_1 &&
            i.caption_level_2 === "مصاحبه"
        );
        const itemScore1 = this.scoreData.find(
          (i) =>
            i.caption_level_1 === item.caption_level_1 &&
            i.caption_level_2 === "تحقیقات"
        );
        return {
          caption_level_1: item.caption_level_1,
          score0: pathOr(null, ["score"], itemScore0),
          score1: pathOr(null, ["score"], itemScore1),
        };
      });
      const reportConclusionItems = refactorScoreData.reduce((acc, cur) => {
        return !acc.find(
          (accItem) => accItem.caption_level_1 === cur.caption_level_1
        )
          ? [...acc, cur]
          : acc;
      }, []);

      const itemsObject = {
        default: this.scoreData,
        reportConclusion: reportConclusionItems,
        reportResource: this.resourceData.map((row, index) => {
          return {
            row: index + 1,
            ...row,
          };
        }),
      };
      return includes(this.componentType, ["reportSearch", "reportInterview"])
        ? itemsObject.default
        : itemsObject[this.componentType];
    },
  },
  created() {
    this.callInCreatedHook && this.fetchData();
  },
  methods: {
    generateApiUrl,
    renderDynamicData(key) {
      const titles = {
        reportSearch: {
          title: this.$lang.reportSearchLabel,
          groupId: 8,
        },
        reportInterview: {
          title: this.$lang.reportInterviewLabel,
          groupId: 9,
        },
        reportConclusion: {
          title: "",
          groupId: 10,
        },
        reportResource: {
          title: this.$lang.reportResearchResourceLabel,
          groupId: null,
        },
      };
      return pathOr("", [key], titles[this.componentType]);
    },
    async getFinalReportScore() {
      /* this method called with refs in parent component */

      // check requirement
      if (!this.code) {
        return false;
      }

      this.scoreData = [];
      try {
        this.$emit("loading", true);
        const groupId = this.renderDynamicData("groupId");
        let url = generateApiUrl(
          ["report", "final_report_score"],
          [this.code, groupId]
        );
        if (this.calculateData) {
          url = generateApiUrl(
            ["report", "final_report_conclusion"],
            [this.code]
          );
        }
        const response = await this.$httpService.get(url);
        this.scoreData = [...pathOr([], ["data", "data", "result"], response)];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.$emit("loading", false);
      }
    },
    async getFinalReportResource() {
      // check requirement
      if (!this.code) {
        return false;
      }

      this.resourceData = [];
      try {
        this.$emit("loading", true);
        const url =
          this.$config.api_url +
          this.$config.report.final_report_research.replace("{0}", this.code);

        const response = await this.$httpService.get(url);
        this.resourceData = [...pathOr([], ["data", "data"], response)];
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.$emit("loading", false);
      }
    },
    fetchData() {
      if (this.componentType === "reportResource") {
        this.getFinalReportResource();
      } else {
        this.getFinalReportScore();
      }
    },
  },
};
</script>
